import React from 'react';
import { Card, Col, Row, Tag, Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { MetricScore } from '../types';

const { Text } = Typography;

interface Props {
    metrics: MetricScore[];
    /** DSP 卡片不展示连续天数与突发系数 */
    showBurst?: boolean;
}

const MetricScoreCards: React.FC<Props> = ({ metrics, showBurst = true }) => {
    const { t } = useTranslation();
    const I18N = 'dashboard.dailyMeeting';

    return (
        <Row gutter={[12, 12]}>
            {metrics.map((metric) => {
                const missing = metric.actual === null;
                const belowTarget = !missing && metric.gap < 0;
                return (
                    <Col key={metric.metric} xs={24} sm={12} xl={6}>
                        <Card size="small" bordered styles={{ body: { padding: 8 } }}>
                            <Text type="secondary" className="text-xs whitespace-nowrap">
                                {t(`${I18N}.metric.${metric.metric}`)}
                            </Text>
                            <div className="flex items-baseline gap-1 whitespace-nowrap">
                                <Text strong className="text-lg whitespace-nowrap">
                                    {missing ? '-' : `${metric.actual!.toFixed(2)}%`}
                                </Text>
                                {!missing && (
                                    <Text type={belowTarget ? 'danger' : 'success'} className="text-xs whitespace-nowrap">
                                        {metric.gap >= 0 ? '+' : ''}{metric.gap.toFixed(2)}pp
                                    </Text>
                                )}
                            </div>
                            <Text type="secondary" className="text-xs whitespace-nowrap">
                                {t(`${I18N}.metric.target`, { value: metric.target.toFixed(1) })}
                            </Text>
                            <div className="mt-1 flex items-center gap-1 flex-wrap">
                                <Tooltip title={t(`${I18N}.metric.contributionTip`)}>
                                    <Tag color={metric.contribution > 0 ? 'error' : 'default'} className="!m-0">
                                        {t(`${I18N}.metric.contribution`, { value: metric.contribution.toFixed(2) })}
                                    </Tag>
                                </Tooltip>
                                {showBurst && metric.consecutiveDays > 0 && (
                                    <Tooltip title={t(`${I18N}.metric.burstTip`, { value: metric.burst.toFixed(2) })}>
                                        <Tag color="warning" className="!m-0">
                                            {t(`${I18N}.metric.consecutiveDays`, { days: metric.consecutiveDays })}
                                        </Tag>
                                    </Tooltip>
                                )}
                            </div>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
};

export default MetricScoreCards;
